export const baseUrl = 'https://api.sons.co.uk/api/'; //TODO - move to env
export const apiBase = '/api/';

export const hostUrl = 'https://api.sons.co.uk/';

export const feBase = 'https://shop.sons.co.uk/'

export const stripeMode = 'test';
